import { useNavigate } from 'react-router-dom';
import { hotRecommendations } from '@/mocks/videoData';

export default function HotRecommendations() {
  const navigate = useNavigate();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">大家都在看的精彩内容</p>
          </div>
          <a
            href="/category/movie"
            onClick={(e) => { e.preventDefault(); navigate('/category/movie'); }}
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 cursor-pointer whitespace-nowrap"
          >
            查看更多
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotRecommendations.map((item) => (
            <a
              key={item.id}
              href={`/article/${item.slug}`}
              onClick={(e) => { e.preventDefault(); navigate(`/article/${item.slug}`); }}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded">
                    {item.rating}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
                  <span className="text-white text-xs font-medium flex items-center gap-1">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-play-fill text-sm"></i>
                    </span>
                    立即观看
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">
                {item.category} · {item.year}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}